import React from "react";
import { skills, companyInfo } from "../mock";

const About = () => {
  return (
    <section id="about" className="icg-section">
      <div className="icg-container grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <span className="icg-eyebrow"><span className="icg-dot" /> About us</span>
          <h2 className="font-display font-semibold tracking-tight mt-5"
              style={{ fontSize: "clamp(36px, 5vw, 64px)", lineHeight: 1.02 }}>
            We are a
            <br />
            <span className="font-serif-it text-[color:var(--icg-accent)]">creative</span> agency.
          </h2>
        </div>

        <div className="md:col-span-8 md:pl-8">
          <p className="text-lg md:text-xl leading-relaxed text-[color:var(--icg-ink-soft)]">
            {companyInfo.name} {companyInfo.suffix} was founded by {companyInfo.founder} in
            {" "}{companyInfo.foundedYear} in Detroit, Michigan as a graphic and web design studio for
            small businesses. Today we offer full design, development, marketing and advertising
            services — from graphic design and web builds to video editing, event marketing and
            multi-media ad placement.
          </p>
          <p className="mt-6 text-lg leading-relaxed text-[color:var(--icg-muted)]">
            When we started, there were 765,247 small businesses in the Detroit area alone. We
            believed then — and we still believe today — that great work should be affordable
            enough for the smallest one-person operation, and sharp enough to help the biggest
            names in the room stand out. The more successful small businesses there are, the more
            jobs get created. That's the whole point.
          </p>

          <div className="mt-12 grid sm:grid-cols-2 gap-x-10 gap-y-6">
            {skills.map((s, i) => (
              <div key={s.label}>
                <div className="flex items-center justify-between text-sm mb-2">
                  <span className="font-display font-medium">{s.label}</span>
                  <span className="text-[color:var(--icg-muted)]">{s.value}%</span>
                </div>
                <div className="icg-progress-bar">
                  <span style={{ width: `${s.value}%`, animationDelay: `${i * 0.1}s` }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
